// agentsIcons.js — extracted constants
import { Route, Bot, Zap, Rss, Award, MessageSquareQuote, ChartNoAxesCombined, GitCompareArrows } from "lucide-react";

export const agents_icons = [
  { name: "Orchestrator Agent", icon: Route },
  { name: "Spend Analytics Agent", icon: Bot },
  { name: "Market Intel Agent", icon: Rss },
  { name: "Supplier Risk Agent", icon: Zap },
  { name: "Supplier Discovery Agent", icon: GitCompareArrows },
  { name: "Benchmarking Agent", icon: ChartNoAxesCombined },
];
